<script>
import { mapActions, mapGetters, mapState } from 'vuex';

import CsrfTokenInput from '~/components/csrf_token_input.vue';

import CancelMessage from './cancel_message.vue';
import CustomerFields from './customer_fields.vue';
import MerchantContactFooter from './merchant_contact_footer.vue';
import OrderBump from './order_bump.vue';
import PaymentButton from './payment_button.vue';
import PaymentFooter from './payment_footer.vue';
import PaymentMethods from './payment_methods.vue';
import PaymentSummary from './payment_summary.vue';
import PaymentTypeTabs from './payment_type_tabs.vue';
import ProductInfo from './product_info.vue';
import Testimonials from './testimonials.vue';
import TestPaymentBanner from './test_payment_banner.vue';
import TrustBadges from './trust_badges.vue';

export default {
  components: {
    CancelMessage,
    CsrfTokenInput,
    CustomerFields,
    MerchantContactFooter,
    OrderBump,
    PaymentButton,
    PaymentFooter,
    PaymentMethods,
    PaymentSummary,
    PaymentTypeTabs,
    ProductInfo,
    Testimonials,
    TestPaymentBanner,
    TrustBadges
  },

  data() {
    return {
      submitted: false
    };
  },

  computed: {
    ...mapState([
      'amountsUrl',
      'formUrl',
      'product'
    ]),

    ...mapGetters([
      'hasInputErrors',
      'getProductTitle'
    ]),

    disabled() {
      return this.submitted;
    }
  },

  methods: {
    ...mapActions([
      'validateField'
    ]),


    submitForm(event) {
      const form = event.target;
      this.validateForm(form.elements);
      if (this.hasInputErrors) {
        event.preventDefault();
      } else {
        this.submitted = true;
      }
    },

    validateForm(elements) {
      [...elements].forEach((inputElement) => {
        const inputKey = inputElement.id.split('payment_page_')[1];
        this.validateField(inputKey);
      });
    },

    scrollToTop() {
      setTimeout(() => {
        window.scrollTo(0, 0);
      }, 500);
    }
  }
};
</script>

<template>
  <div class="c-marketing-page">
    <test-payment-banner
      v-if="product.isTestMode"
      class="c-marketing-page--sticky"
    />

    <div class="c-marketing-page__page">
      <cancel-message @show="scrollToTop" />

      <form
        :action="formUrl"
        method="post"
        target="_top"
        @submit="submitForm"
      >
        <csrf-token-input />

        <div class="c-marketing-page__container">
          <svg
            class="c-marketing-page__mask"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 10 10"
            preserveAspectRatio="xMaxYMid slice"
          >
            <defs>
              <linearGradient id="mask-gradient">
                <stop offset="0%" />
                <stop offset="100%" />
              </linearGradient>
            </defs>

            <polygon points="0,0 10,0 10,4.72 0,6.14" />
          </svg>

          <div class="c-marketing-page__header pb-2">
            <product-info
              :title="getProductTitle"
              :description="product.description"
              :show-description="product.showDescription"
              :product-image-url="product.productImageUrl"
              :company-image-url="product.companyImageUrl"
              :usps="product.usps"
            />
          </div>

          <div class="c-marketing-page__content pt-5">
            <div class="row g-4">
              <div class="col-md-6">
                <div class="c-panel">
                  <payment-type-tabs />

                  <customer-fields />

                  <payment-methods />

                  <order-bump
                    v-if="product.orderBumpEnabled"
                  />
                </div>
              </div>

              <div class="col-md-6 c-marketing-page--sticky c-marketing-page--sticky--spacing">
                <div class="c-panel c-panel--primary">
                  <payment-summary />

                  <payment-button
                    :disabled="disabled"
                    :text="product.buttonText"
                  />

                  <trust-badges />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="py-4 py-md-5">
          <payment-footer />
        </div>
      </form>
    </div>

    <testimonials />

    <template v-if="product.showFooter">
      <div class="mb-md-5" />
      <merchant-contact-footer />
    </template>
  </div>
</template>
